// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"5d66cc7a","46":"5176d13d","143":"d70b6a38","148":"bac65a68","219":"125995da","305":"bba5a0a9","413":"31b90777","414":"ef42a5bc","415":"f34f9f9a","484":"0d340599","567":"cb7d0c5b","593":"fcd26dc4","778":"2c27649f"}[chunkId] + ".chunk.js";
};